'use client';

import { FC } from 'react';
import { Button } from 'atoms/Button';
import { ParseBBCode } from 'atoms/ParseBBCode';
import { Span } from 'atoms/Typography';
import { Body, Title } from 'atoms/Typography/Typography';
import { Price } from 'molecules/Price';
import { ProductImage } from 'molecules/ProductImage';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useRouter } from 'modules/next/hooks';
import { useCart } from 'modules/shop/cart/hooks';
import { AppRoutes } from 'modules/shop/routes';
import { Product } from 'commerce/scayle/utils/adapter';
import styles from './styles.module.css';

export const CartPopupContent: FC = () => {
  const { cart } = useCart();
  const router = useRouter();
  const t = useTranslations();
  const isEmpty = !cart?.items?.length;
  const handleClick = () => {
    router.push(AppRoutes.CART);
  };

  if (!cart) {
    return null;
  }

  const cartItems = cart.items
    .filter((item) => !!item?.product)
    .map((item) => {
      const product = Product.createProduct(item.product);
      return { ...item, product };
    });

  return (
    <>
      <div className={styles.header}>
        <Title type="md" className={styles.title}>
          {t('basket.texts.cartTitle')}
        </Title>
        {isEmpty && (
          <Body type="md" className={styles.subTitle}>
            {t('basket.texts.cartSubTitle')}
          </Body>
        )}
      </div>
      {!isEmpty && (
        <>
          <div className={styles.productList}>
            {cartItems.map(({ product, price, quantity }) => (
              <div key={product.referenceKey} className={styles.product}>
                <ProductImage
                  hash={product.coverImage}
                  className={styles.image}
                />
                <div className={styles.productInfo}>
                  <Body type="md" weight="medium">
                    <ParseBBCode content={product.name} />
                  </Body>
                  <Body
                    type="md"
                    weight="medium"
                    className={styles.productQuantity}
                  >
                    {t('basket.texts.quantity')} : {quantity}
                  </Body>
                </div>
                <Price
                  amount={price.total.withTax}
                  currencyCode={price.total.currencyCode}
                  isCrossed={false}
                  size="regular"
                  className={styles.price}
                />
              </div>
            ))}
          </div>
          <div className={styles.footer}>
            <div className={styles.total}>
              <Span className={styles.totalText}>
                {t('basket.texts.total')}
              </Span>
              <Price
                amount={cart.cost.withTax}
                currencyCode={cart.cost.currencyCode}
                isCrossed={false}
                size="regular"
                className={styles.totalValue}
              />
            </div>
            <Button
              color="deep-purple"
              onClick={handleClick}
              className={styles.button}
            >
              {t('basket.texts.cartButton')}
            </Button>
            <Body type="md" className={styles.notification}>
              {t('basket.texts.vatNotification')}
            </Body>
          </div>
        </>
      )}
    </>
  );
};
